import { Stack, type StackProps } from '@mui/material'
import { mergeSx } from 'merge-sx'
import { useMemo } from 'react'

export interface IIconBoxProps {
  sx?: StackProps['sx']
  size?: 'sm' | 'medium' | 'large' | 'xl'
}

export const IconBox: Settle.FC<IIconBoxProps> = ({ children, sx, size, ...rest }) => {
  const dimensions = useMemo(() => {
    switch (size) {
      case 'xl':
        return {
          size: 64,
          fontSize: '2.5rem',
        }
      case 'large':
        return {
          size: 56,
          fontSize: '2rem',
        }
      case 'sm':
        return {
          size: 40,
          fontSize: '1.5rem',
        }
      case 'medium':
      default:
        return {
          size: 48,
          fontSize: '1.75rem',
        }
    }
  }, [size])

  return (
    <Stack
      sx={mergeSx(
        {
          flexShrink: 0,
          width: dimensions.size,
          height: dimensions.size,
          borderRadius: '50%',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: (theme) => theme.tokens.ThemeColorCommonOnSurfaceContainer,
          '& svg': {
            fontSize: dimensions.fontSize,
          },
        },
        sx,
      )}
      {...rest}
    >
      {children}
    </Stack>
  )
}
